// Navigation utility functions
export const ROUTES = {
    HOME: '/home',
    IDEA_VALIDATOR: '/idea-validator',
    MARKET_INSIGHTS: '/market-insights',
    PITCH_DECK: '/pitch-deck',
};

export const getRouteFromScreen = (screen) => {
    switch (screen) {
        case 'Home':
            return ROUTES.HOME;
        case 'IdeaValidator':
            return ROUTES.IDEA_VALIDATOR;
        case 'MarketInsights':
            return ROUTES.MARKET_INSIGHTS;
        case 'PitchDeckAnalyzer':
            return ROUTES.PITCH_DECK;
        default:
            return ROUTES.HOME;
    }
};

export const getScreenFromRoute = (route) => {
    switch (route) {
        case ROUTES.HOME:
            return 'Home';
        case ROUTES.IDEA_VALIDATOR:
            return 'IdeaValidator';
        case ROUTES.MARKET_INSIGHTS:
            return 'MarketInsights';
        case ROUTES.PITCH_DECK:
            return 'PitchDeckAnalyzer';
        default:
            return 'Home';
    }
};
